
import Vue from 'vue';

/**
 * One numbered stage in the provisioning flow. The card owns only its open/closed state and
 * presentation. Whether a stage is complete, active or still locked is decided by the page, which is
 * the only place that can see the whole flow.
 */
export default Vue.extend({
	name: 'ProvisioningStepCard',
	props: {
		value: { type: Boolean, default: false },
		stepNumber: { type: Number, required: true },
		title: { type: String, required: true },
		subtitle: { type: String, default: '' },
		statusText: { type: String, default: '' },
		/** complete | active | idle | blocked. Drives the number chip and status pill colour. */
		tone: { type: String, default: 'idle' },
		/** A locked stage still expands, so an admin can read what is waiting for them. */
		locked: { type: Boolean, default: false },
	},
	computed: {
		isOpen (): boolean {
			return !!this.value;
		},
		paddedNumber (): string {
			return String(this.stepNumber).padStart(2, '0');
		},
	},
	methods: {
		onToggle () {
			this.$emit('input', !this.isOpen);
		},
	},
});
